<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "cityfreight",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "交易规模",
                        data: "shares",
                        unit: "亿元"
                    },
                    {
                        name: "货运量",
                        data: "a160",
                        unit: "万亿吨"
                    },
                    {
                        name: "网约车交易额",
                        data: "a161",
                        unit: "亿元"
                    },
                ],
                name: '同城货运'
            }
        }
    },
    created() {
        this.$store.dispatch('getIndustry', this.params)
    },
}
</script>